'use strict';

angular.module('shiftTraderApp')
  .directive('saUserAvailabilityChangeRequestLineItem', ['AvailabilitySets', 'UserPermissionsService', 'toastr', function (AvailabilitySets, UserPermissionsService, toastr) {
    return {
      templateUrl: 'views/directives/saUserAvailabilityChangeRequestLineItem.html',
      restrict: 'A',
      scope: {
        uacr: '=saUserAvailabilityChangeRequestLineItem',
        me: '='
      },
      link: function postLink(scope, element, attrs, ctrl) {

        scope.state = {
          currentAvailabilitySetLoaded: false,
          isCollapsed: true,
          showCollapseButton: false
        };

        UserPermissionsService.can('availability_sets.view_target', scope.uacr.organization_id)
          .then(function(result) {
            scope.state.canViewTargetHours = result;
          });

        if (scope.uacr.$hasInReviewAvailabilitySet() || scope.uacr.$hasApprovedAvailabilitySet()) {
          AvailabilitySets.getAll({
            user_id: scope.uacr.user_id,
            state: 2
          })
            .then(function(availabilitySets) {
              scope.approvedAvailabilitySets = availabilitySets;
              scope.effectiveAvailabilitySet = _.find(scope.approvedAvailabilitySets, function(availSet) {
                return availSet.$isInEffect();
              });
              scope.state.currentAvailabilitySetLoaded = true;
              calculateAvailabilityDiffWithCurrent();
            }, function() {
              console.log('error loading availabilitySet');
            });
        }

        if (scope.uacr.$hasInReviewAvailabilitySet()) {
          scope.availabilitySetInQuestion = scope.uacr.$inReviewAvailabilitySet();
        } else if (scope.uacr.$hasApprovedAvailabilitySet()) {
          scope.availabilitySetInQuestion = scope.uacr.$approvedAvailabilitySet();
        }

        var calculateCurrentState = function() {
          if (scope.uacr.$hasBeenRespondedTo()) {
            if (scope.uacr.$hasPendingAvailabilitySet()) {
              //scope.state.currStateClass = 'pending';
            } else if (scope.uacr.$hasInReviewAvailabilitySet()) {
              scope.state.currStateClass = 'in_review';
            } else if (scope.uacr.$hasApprovedAvailabilitySet()) {
              scope.state.currStateClass = 'approved';
            } else {
              scope.state.currStateClass = 'awaiting_new_response';
            }

          } else {
            // user has not replied
            scope.state.currStateClass = 'not_submitted';
          }
          var e = element.find('.sa_user_availability_change_request_line_item');
          e.removeClass(['in_review', 'approved', 'awaiting_new_response', 'not_submitted'].join(' ')).addClass(scope.state.currStateClass);
        };

        var calculateAvailabilityDiffWithCurrent = function() {
          var diffByDayInMins = [];
          var diffByDayInHours = [];
          var currAvail = scope.effectiveAvailabilitySet;
          if (_.isUndefined(currAvail)) {
            currAvail = {
              availability_rules: []
            };
          }

          var newAvail;

          if (scope.uacr.$inReviewAvailabilitySet()) {
            newAvail = scope.uacr.$inReviewAvailabilitySet();
          } else if (scope.uacr.$hasApprovedAvailabilitySet()) {
            newAvail = scope.uacr.$approvedAvailabilitySet();
          }

          var currMinByDayByType = [];
          var newMinByDayByType = [];

          _.each(_.range(7), function(dayNum) {
            // loop over each day and find the relevant availability_rules
            var currDayRules = _.where(currAvail.availability_rules, {day_of_week: dayNum});
            var newAvailRules = _.where(newAvail.availability_rules, {day_of_week: dayNum});

            _.each([[currMinByDayByType, currDayRules], [newMinByDayByType, newAvailRules]], function(obj) {
              var temp = {
                green: _.reduce(obj[1], function(sum, rule) {
                  if (rule.avail) {
                    return sum + rule.end_time_minutes - rule.start_time_minutes;
                  } else {
                    return sum;
                  }
                }, 0),
                red: _.reduce(obj[1], function(sum, rule) {
                  if (!rule.avail) {
                    return sum + rule.end_time_minutes - rule.start_time_minutes;
                  } else {
                    return sum;
                  }
                }, 0)
              };


              _.each(_.keys(temp), function(key) {
                if (_.isUndefined(temp[key])) {
                  temp[key] = 0;
                }
              });



              temp.gray = 24 * 60 - temp.green - temp.red;
              obj[0].push(temp);
            });

            diffByDayInMins.push({
              green: newMinByDayByType[dayNum].green - currMinByDayByType[dayNum].green,
              red: newMinByDayByType[dayNum].red - currMinByDayByType[dayNum].red,
              gray: newMinByDayByType[dayNum].gray - currMinByDayByType[dayNum].gray
            });
          });

          diffByDayInHours = _.map(diffByDayInMins, function(diffDay) {
            return {
              green: parseFloat((diffDay.green / 60.0).toFixed(1)),
              red: parseFloat((diffDay.red / 60.0).toFixed(1)),
              gray: parseFloat((diffDay.gray / 60.0).toFixed(1))
            }
          });

          _.each(diffByDayInHours, function(diffDay) {
            _.each(_.keys(diffDay), function(key) {
              if (diffDay[key] > 0) {
                diffDay[key] = '+' + diffDay[key];
              }
            });
          });

          scope.diffByDayInMins = diffByDayInMins;
          scope.diffByDayInHours = diffByDayInHours;

          scope.diffByTypeInHours = {
            green: 0,
            gray: 0,
            red: 0
          };

          _.each(scope.diffByDayInMins, function(diffDay) {
            _.each(_.keys(scope.diffByTypeInHours), function(key) {
              scope.diffByTypeInHours[key] += diffDay[key];
            });
          });

          _.each(_.keys(scope.diffByTypeInHours), function(key) {
            scope.diffByTypeInHours[key] = parseFloat((scope.diffByTypeInHours[key] / 60.0).toFixed(1));

            if (scope.diffByTypeInHours[key] > 0) {
              scope.diffByTypeInHours[key] = '+' + scope.diffByTypeInHours[key];
            }
          });
        };

        calculateCurrentState();

        scope.approveSetInQuestion = function() {
          var updateData = {
            state: AvailabilitySets.stateMapping.APPROVED
          };
          scope.$emit('sa:availabilityManagementViewRequest:updateStats', true);

          scope.availabilitySetInQuestion.$update(updateData)
            .then(function(response) {
              scope.availabilitySetInQuestion = response;
              toastr.success('Availability set approved!', 'Success');
              var setIndex = _.findIndex(scope.uacr.availability_sets, {id: response.id});

              scope.uacr.availability_sets[setIndex] = response;

              calculateCurrentState();
              calculateAvailabilityDiffWithCurrent();

              scope.$emit('sa:availabilityManagementViewRequest:updateStats', true);

            }, function() {
              toastr.error('Availability set was not approved. Please try again later.', 'Error');
            });
        };
      }
    };
  }]);
